import React, { useEffect, useState } from "react";
import { DialogActions } from "@material-ui/core";
import { TabPanel, TabView } from "primereact/tabview";
import { Card } from "react-bootstrap";
import { useFormikContext } from "formik";
import { Editor } from "primereact/editor";
import DialogLayout from "../../../../partials/content/DialogLayout";
import {
  FormDateField,
  FormSelectField,
  FormTextField,
} from "../../../../partials/content/Forms/FormField";
//import { getIncomingPaymentByInvoice } from "../../../../services/finance/incomingPayment";
import { getGlAccounts } from "../../../../services/setup/finance/financeSetupService";
import SearchCurrency from "../../setup/finance/searchCurrency";
import SearchInPaymentDocRef from "./searchInPaymentDocRef";

function IncomingPaymentContent({ showBottomSubmit = false }) {
  //const [payments, setPayments] = useState([]);
  const [openSearchCurrency, setOpenSearchCurrency] = useState(false);
  //const [totalPayment, setTotalPayment] = useState(0);
  const [openSearchInvoice, setOpenSearchInvoice] = useState(false);
  const [cashAccounts, setCashAccounts] = useState([]);
  const { values, setFieldValue } = useFormikContext();
  useEffect(() => {
    getGlAccountsData();
  }, []);
  return (
    <React.Fragment>
      <div className="tabview">
        <div className="card">
          <TabView className="tabview" scrollable>
            <TabPanel header="A/R Payment Main" rightIcon="fas fa-th-large">
              <div className="row">
                <div className="col-sm-12 col-md-12 col-lg-12">
                  <Card>
                    <Card.Header>
                      <i className="fas fa-window-maximize"></i>
                      <span>
                        <strong>Account Receivable Payment Header</strong>
                      </span>
                    </Card.Header>
                    <Card.Body>
                      <div className="row">
                        <div className="col-sm-6 col-md-6 col-lg-6">
                          <div className="row">
                            <div className="col-sm-12 col-md-12 col-lg-6">
                              <FormSelectField
                                name="docRef"
                                label="Document Reference"
                                options={[
                                  {
                                    value: "1",
                                    label: "Account Receivable Invoice",
                                  },
                                ]}
                              />
                            </div>
                            <div className="col-sm-12 col-md-12 col-lg-6">
                              <FormTextField
                                name="invoiceCode"
                                label="A/R Invoice ID"
                                searchButton
                                readonly
                                onSearchClick={() => {
                                  setOpenSearchInvoice(true);
                                }}
                              />
                            </div>
                          </div>
                          <FormTextField
                            name="customerName"
                            label="Customer Name"
                            readonly
                          />
                          <div className="row">
                            <div className="col-sm-12 col-md-12 col-lg-6">
                              <FormTextField
                                name="currencyCode"
                                label="Currency"
                                readonly
                              />
                            </div>
                            <div className="col-sm-12 col-md-12 col-lg-6">
                              <FormTextField
                                label="Exchange Rate To Base Currency"
                                name="exchangeRate"
                                currencyField
                                fullDecimals={true}
                                readonly
                              />
                            </div>
                          </div>
                        </div>
                        <div className="col-sm-6 col-md-6 col-lg-6">
                          <FormSelectField
                            name="cashAccountID"
                            label="Cash Account"
                            options={cashAccounts}
                          />
                          <FormDateField
                            name="paymentDate"
                            label="Payment Date"
                          />
                          <div className="row">
                            <div className="col-sm-6 col-md-6 col-lg-6">
                              <FormTextField
                                label="A/R Invoice Amount"
                                name="invoiceAmount"
                                currencyField
                                readonly
                              />
                            </div>
                            <div className="col-sm-6 col-md-6 col-lg-6">
                              <FormTextField
                                label="Unpaid Amount"
                                name="unpaidAmount"
                                currencyField
                                readonly
                              />
                            </div>
                          </div>
                          <FormTextField
                            label="Payment Amount"
                            name="paymentAmount"
                            currencyField
                          />
                        </div>
                      </div>
                    </Card.Body>
                  </Card>
                </div>
              </div>
            </TabPanel>
            <TabPanel header="Note" rightIcon="fas fa-sticky-note">
              <div className="row">
                <div className="col-sm-12 col-md-12 col-lg-12">
                  <Card>
                    <Card.Header>
                      <i className="fas fa-sticky-note"></i>
                      <span>
                        <strong>Note</strong>
                      </span>
                    </Card.Header>
                    <Card.Body>
                      <Editor
                        style={{ height: "200px", width: "100%" }}
                        onTextChange={(e) => {
                          setFieldValue("note", e.htmlValue);
                        }}
                        value={values.note}
                        placeholder="Type your notes here..."
                      />
                    </Card.Body>
                  </Card>
                </div>
              </div>
            </TabPanel>
          </TabView>
        </div>
      </div>
      <DialogLayout
        open={openSearchInvoice}
        title="Search Invoice"
        onCloseDialog={() => {
          setOpenSearchInvoice(false);
        }}
        fullScreen={false}
      >
        <SearchInPaymentDocRef
          onSelectInvoice={(invoice) => {
            setFieldValue("invoiceID", invoice.ID);
            setFieldValue("invoiceCode", invoice.invoiceCode);
            setFieldValue("customerID", invoice.customerID);
            setFieldValue("customerName", invoice.customer.customerName);
            setFieldValue("currencyID", invoice.currencyID);
            setFieldValue("currencyCode", invoice.currency.currencyCode);
            setFieldValue("invoiceAmount", invoice.billAmount);
            setFieldValue("paymentAmount", invoice.unpaidAmount);
            setFieldValue("unpaidAmount", invoice.unpaidAmount);
            setFieldValue("cashAccountID", invoice.cashAccountID);
            setOpenSearchInvoice(false);
            /*
            getIncomingPaymentByInvoice(invoice.ID)
              .then((response) => {
                let totalPaymentData = 0;
                const { data } = response.data;
                data.incomingPayment.forEach((item) => {
                  totalPaymentData += item.paymentAmount;
                });
                setTotalPayment(totalPaymentData);
                setPayments(response.data);
                setOpenSearchInvoice(false);
              })
              .catch((error) => {});
              */
          }}
        />
        <DialogActions>
          <button
            type="button"
            className="btn btn-label-danger btn-md btn-pill btn-bold"
            onClick={() => {
              setOpenSearchInvoice(false);
            }}
          >
            <i className="fas fa-window-close"></i>
            Close
          </button>
        </DialogActions>
      </DialogLayout>
      <DialogLayout
        open={openSearchCurrency}
        title="Search Currency"
        onCloseDialog={() => {
          setOpenSearchCurrency(false);
        }}
        maxWIdth="sm"
      >
        <SearchCurrency
          onSelectCurrency={(currency) => {
            setFieldValue("currencyID", currency.ID);
            setFieldValue("currencyCode", currency.currencyCode);
            setOpenSearchCurrency(false);
          }}
        />
        <DialogActions>
          <button
            type="button"
            className="btn btn-label-danger btn-md btn-pill btn-bold"
            onClick={() => {
              setOpenSearchCurrency(false);
            }}
          >
            <i className="fas fa-window-close"></i>
            Close
          </button>
        </DialogActions>
      </DialogLayout>
    </React.Fragment>
  );
  async function getGlAccountsData() {
    const response = await getGlAccounts("1");
    const { data } = response.data;
    const cashAccounts = data.glAccounts;
    const cashAccountList = [];
    for (const account of cashAccounts) {
      cashAccountList.push({
        label: account.accountName,
        value: account.ID,
      });
    }
    setCashAccounts(cashAccountList);
  }
}

export default IncomingPaymentContent;
